export default {"src":"/_next/static/media/icon_decentralized_design.7a0bdc98.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};